var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'pool-annotation',
    ("pool-annotation--" + _vm.number)
  ]},[(_vm.number > 0)?_c('img',{attrs:{"src":("/img/annotation-" + _vm.number + ".png")}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }